// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1TdRf","location":"Header_location__2BXG-"};